import React from "react";
import { styled } from "@mui/system";
import Tooltip from "@mui/material/Tooltip";
export const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  "& .MuiTooltip-tooltip": {
    position: "relative",
    backgroundColor: "#E8E8E8",
    color: "#000000",
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15);",
    fontSize: "10px",
    lineHeight: "16px",
    whiteSpace: "pre-line",
    padding: "5px 8px",
    borderRadius: "4px",

    "& .tooltipWrapper": {
      display: "flex",
      flexDirection: "column",
      gap: "0.5rem"
    }
  },
  "& .MuiTooltip-arrow": {
    color: "#E8E8E8"
  }
}));
